import React from 'react';

/**
 * Text input atom. Supports an optional leading icon (e.g. search).
 */
export default function Input({
  value,
  onChange,
  placeholder,
  type = 'text',
  icon,
  className = '',
  inputClassName = '',
  ...props
}) {
  return (
    <div className={`ca-input-wrap ${className}`.trim()}>
      {icon ? <span className="ca-input-wrap__icon">{icon}</span> : null}
      <input
        type={type}
        className={`ca-input ${icon ? 'ca-input--with-icon' : ''} ${inputClassName}`.trim()}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        {...props}
      />
    </div>
  );
}
